import { create } from 'zustand';
import { UserSessionResponse, UIConfig } from '../app/types/sessionTypes';

// Stato iniziale del token (stesso di Redux)
const initialUser: UserSessionResponse = {
  firstName: '',
  lastName: '',
  email: '',
  userId: '',
  credit100: 0,
  credit51c3: 0,
  d: '',
  t: {
    value: '',
    ApiBaseURL: '',
    ApiCRMUsername: '',
    ImageBaseURL: '',
    ImageCasketBaseURL: '',
    expiry: 0
  },
  uiConfig: {
    logoUrl: '',
    primaryColor: '',
    secondaryColor: '',
    ctaColor: '',
    ctaTextColor: '',
    appTitle: '',
    minFilter: 0,
    maxFilter: 0
  },
  collections: [], // collections specifiche del partner
  categories: [] // categories specifiche del partner
};

// Interfaccia per lo store
interface UserState {
  user: UserSessionResponse;
  appConfig: UIConfig | null;
  // Actions
  setUser: (user: UserSessionResponse) => void;
  updateUser: (updates: Partial<UserSessionResponse>) => void;
  resetUser: () => void;
  setAppConfig: (config: UIConfig) => void;
  resetAppConfig: () => void;
  // Selectors per convenienza
  isLoggedIn: () => boolean;
  hasValidSession: () => boolean;
}

// Store Zustand per l'utente
export const useUserStore = create<UserState>()((set, get) => ({
  user: initialUser,
  appConfig: null,
  
  // Setta l'utente completo (equivalente a updateUser action di Redux)
  setUser: (user: UserSessionResponse) => set({ user }),
  
  // Aggiorna parzialmente l'utente
  updateUser: (updates: Partial<UserSessionResponse>) => set((state) => ({
    user: { ...state.user, ...updates }
  })),
  
  // Reset dell'utente allo stato iniziale
  resetUser: () => set({ user: initialUser }),
  
  // Setta la configurazione UI
  setAppConfig: (config: UIConfig) => set({ appConfig: config }),
  
  // Reset della configurazione UI
  resetAppConfig: () => set({ appConfig: null }),
  
  // Selector per verificare se l'utente è loggato
  isLoggedIn: () => {
    const { user } = get();
    return user.d.length > 0;
  },
  
  // Selector per verificare se la sessione è valida
  hasValidSession: () => {
    const { user } = get();
    return user.d.length > 0 && user.email.length > 0;
  }
}));

// Export dell'utente iniziale per compatibilità
export { initialUser };

// Export del tipo UIConfig per riutilizzo
export type { UIConfig }; 